/*global localStorage  */
let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let esUtils = require('ES/utils/esUtils');
let ProOnly = require('../../../../../widgets/ProOnly');
let FormMixin = require('ES/widgets/forms/FormMixin');
let Constants = require('../../../../../../utils/Constants');
let SearchAContactService = require("./SearchAContactService");

let ContactGrabber = dd.createClass({
	mixins: [FormMixin],
	getInitialValues: function () {
		let defaultGrabservice = localStorage.getItem('default_grab_service');
		defaultGrabservice = (_.isEmpty(defaultGrabservice)) ? 'EP' : defaultGrabservice;
		return {
			grabservice: defaultGrabservice
		};
	},
	buildFields: function () {
		return {
			grabservice: {
				type: 'select',
				options: _.mapValues(Constants.GRAB_SERVICES, function (value) {
					return 'from ' + value;
				})
			}
		};
	},
	render: function () {
		let fields = this.buildFields();
		let errors = this.state.errors || {};
		let error = errors['grabservice'];

		return dd.form({onSubmit: this._form_onSubmit},
			dd.div({className: error ? ' has-error' : null},
				dd.div({className: 'input-group'},
					dd.span({className: 'input-group-btn'},
						dd.button({className: 'btn btn-default pull-left', type: 'submit'}, 'Grab')
					),
					this._form_buildInput(fields.grabservice, 'grabservice')
				),
				error ? dd.span({className: 'help-block'}, error) : null
			)
		);
	}
});

module.exports = dd.createClass({
	getInitialState: function () {
		return {search_service: null};
	},
	__onSubmit: function (data) {
		localStorage.setItem('default_grab_service', data.grabservice);
		this.setState({search_service: data.grabservice});
	},
	__onClose: esUtils.wrapPreventDefault(function () {
		this.setState({search_service: null});
	}),
	render: function () {
		let event = this.props.event;

		return dd.div({className: 'ContactGrabber'},
			ProOnly({sids: event.sids},
				ContactGrabber({onSubmit: this.__onSubmit})
			),
			this.state.search_service ? SearchAContactService({service: this.state.search_service, event: event, onClose: this.__onClose}) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ContactGrabber/index.js